import { useState } from "react";
import { Controller, FieldValues, Path } from "react-hook-form";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

import { SelectForm, SelectOptionTypes } from "../../../components/Input";
import { SelectSheet } from "../../../components/MobileForm";
import { FieldError } from "../../../components/FormPanel";
import { FullWidthSelectPill } from "./styles";
import { ResponsiveFormSelectProps } from "./types";

export const ResponsiveFormSelect = <
  TValues extends FieldValues,
  TName extends Path<TValues>,
>({
  isCompact,
  name,
  control,
  options,
  sheetTitle,
  rules,
  required = true,
  disabled = false,
  testId,
  placeholder = "Select…",
}: ResponsiveFormSelectProps<TValues, TName>) => {
  const [isSheetOpen, setIsSheetOpen] = useState(false);

  if (!isCompact) {
    return (
      <SelectForm
        testId={testId}
        rules={rules}
        required={required}
        defaultValue={null}
        name={name}
        control={control}
        options={options}
        disabled={disabled}
      />
    );
  }

  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({ field, fieldState: { error } }) => {
        const selected = field.value as SelectOptionTypes | null;
        return (
          <>
            <FullWidthSelectPill
              type="button"
              id={testId}
              data-testid={testId}
              disabled={disabled}
              onClick={() => setIsSheetOpen(true)}
            >
              {selected?.label ?? placeholder}
              <KeyboardArrowDownIcon />
            </FullWidthSelectPill>
            {error ? <FieldError>{error.message}</FieldError> : null}
            <SelectSheet
              isOpen={isSheetOpen}
              title={sheetTitle}
              options={options}
              selectedValue={selected?.value}
              onSelect={(option) => {
                field.onChange(option);
                setIsSheetOpen(false);
              }}
              onClose={() => setIsSheetOpen(false)}
            />
          </>
        );
      }}
    />
  );
};
